var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueCalender(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H27.9954C32.4136 0 35.9954 3.58172 35.9954 8V27.9954C35.9954 32.4136 32.4136 35.9954 27.9954 35.9954H8C3.58172 35.9954 0 32.4136 0 27.9954V8Z",
    fill: "#F3E8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.668 9.66992V13.0011",
    stroke: "#9810FA",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3281 9.66992V13.0011",
    stroke: "#9810FA",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8284 11.335H12.1695C11.2496 11.335 10.5039 12.0807 10.5039 13.0005V24.6595C10.5039 25.5794 11.2496 26.3251 12.1695 26.3251H23.8284C24.7483 26.3251 25.494 25.5794 25.494 24.6595V13.0005C25.494 12.0807 24.7483 11.335 23.8284 11.335Z",
    stroke: "#9810FA",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5039 16.332H25.494",
    stroke: "#9810FA",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCalender);
export default __webpack_public_path__ + "static/media/blueCalender.ce1c4fe70ad981ae652134c6b12b9568.svg";
export { ForwardRef as ReactComponent };